import TAGGED from "../modules/tagged_content"

const [ w, d, content, mq ] = [ window, document, 'news', window.matchMedia("(max-width: 900px)") ]


const init  = () => {

  //サイドバーのアーカイブ表示をカスタム
  const $archiveList = $( '.list_cat', '.layout_b_pattern6');
  const $monthLink = $( '.list_title1 a', '.layout_b_pattern6');
  const $archiveYear = $('<ul class="archive-year"/>');

  const itemData = {};

  $monthLink.each( (i, v) => {
    const thisYear = $(v).text().match(/^\d{4}/)[0];
    const thisMonth = $(v).text().match(/\/(\d{2})/)[1];
    const thisAmount = $(v).text().match(/\(\d+?\)$/)[0];

    const monthData = {
      month: thisMonth,
      amount: thisAmount,
      href: v.getAttribute('href')
    }
    
    if( itemData[thisYear] && itemData[thisYear].length ) {
      itemData[thisYear].push(monthData);
    } else {
      itemData[thisYear] = [monthData];
    }

  });


  $.each( itemData, ( year, months ) => {
    
    const $yearItem = $(`<li class="year" data-year="${year}"></li>`);

    let $yearButton = $(`<button type="button" href="javascript:void(0)" class="button" data-plugin="accordion" data-toggle="collapse">${year}年</button>`);
    let $archiveMonth = $('<ul class="archive-month"/>');

    $archiveYear.prepend( $yearItem );
    $yearItem.append( $yearButton ).append( $archiveMonth );

    $.each( months, ( i, month ) => {
      const $monthItem = $(`
      <li class="month">
        <a href="${month.href}" title="${year}/${month.month} ${month.amount}">
          <span>${parseInt(month.month)}月</span><small>${month.amount}</small>
        </a>
      </li>`);
      $archiveMonth.append( $monthItem );
    });

    //アーカイブのアコーディオン
    $yearButton.on( 'click', () => {
      $yearItem.toggleClass('is-open');
      $archiveMonth.slideToggle().toggleClass('is-open');
      return false;
    });

  });

  $archiveList.empty().append($archiveYear);

}


// 詳細ページにて実行
const detail_init = async post_id => {
  let articles = await $.getArticles({ content, post_status: 'all' })
  let categories = await $.getCategories({ content })
  let the_article = articles.filter( a => (a.id == post_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  // タグボックス
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<a href="/${content}/?mode=list&tag=${ encodeURI( key ) }" class="tag">#${key}</a>` )
    return `<div class="${content}-detail__tags">${html}</div>`
  }

  // 詳細置き換え
  $('.element_detail').each( ( i, elm_detail ) => {
    let $head = $(`
      <div class="${content}-detail__head">
        <span class="date-cate">
          <span class="date">${w.datetostr( the_article.date * 1000, 'YYYY.MM.DD' )}</span>｜${the_article.category ? `<span class="cate">${the_article.category.name}</span>`: '<span class="cat">その他</span>' }
        </span>
        <h3 class="title">${the_article.title}${the_article.is_new ? '<span class="new">NEW</span>': ''}</h3>
      </div>
    `);
    $('.element_detail > .title, .detail_title').remove()

    $head.prependTo( elm_detail )

    $('.news-detail__head','.element_detail').append( tags( the_article.keywords ));

  })

}


export default function NEWS () {

  // 一覧ページのテンプレート(Vue template)
  const itemTemplate = `
    <div id="main" class="column-3-4">
      <transition-group class="${content}-list" tag="div" name="fade" mode="out-in" :class="[ 'is-paged-' + paged ]">
        <a class="${content}-item" :href="article.href" v-for="( article, ind ) in pagedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
          <figure class="${content}-item__img">
            <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'">
              <img :src="article.thumb" width="200" decoding="async">
            </div>
          </figure>
          <div class="${content}-item__body">
            <div class="${content}-item__title">
              <span class="date-cate">
                <small class="date">{{ datetostr(article.date * 1000 ,"YYYY/MM/DD")}}</small>｜<span class="cate" :class="'is-cat'+article.category.id" v-if="article.category">{{ article.category.name }}</span><span class="cate" v-else="article.category">その他</span>
              </span>
              <span class="subject">
                {{ article.title | truncate(60) }}<span class="new" v-if="article.is_new">NEW</span>
              </span>
            </div>
            <div class="tags" v-if="article.keywords != null">
              <span class="tag" v-for="tag in article.keywords">#{{tag}}</span>
            </div>
          </div>
        </a>
      </transition-group>
      <pagination
        v-if="totalPage > 1"
        :paged="paged"
        :total-page="totalPage"
        :total-item="totalItem"
        :item-count="pagedArticles.length"
        :prevText="'Prev'"
        :nextText="'Next'"
        @change="pageChange"
      />
    </div>
  `

  // カテゴリ一覧ページにて、記事ごとの要素置き換え
  const replaceItemTemplate = item => `
    <a class="${content}-item" href="${item.href}">
      <figure class="${content}-item__img">
        <div class="${content}-item__img-cover" style="background-image:url( ${item.thumb} )">
          <img src="${item.thumb}" width="200">
        </div>
      </figure>
      <div class="${content}-item__body">
        <div class="${content}-item__title">
          <span class="date-cate">
            <span class="date">${item.date.replace( /\//g, '.' )}</span>
          </span>
          <span class="subject">
            ${item.title.str_truncate( 20 )}
            ${item.is_new ? '<span class="new">NEW</span>': ''}
          </span>
        </div>
      </div>
    </a>
  `

  // 関連記事のテンプレート(Vue template)
  const relatedItemTemplate = `
    <div class="${content}-related">
    <div data-plugin="related_articles" class="${content}-list" v-if="relatedArticles.length >= 1">
       <h4 class="${content}-related__title">関連記事</h4>
        <a class="${content}-item" :href="article.href" v-for="article in relatedArticles" :key="article.id">
          <figure class="${content}-item__img">
            <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'"><img :src="article.thumb" width="200"></div>
          </figure>
          <div class="${content}-item__body">
            <div class="${content}-item__title">
              <span class="date-cate"><small class="date">{{ datetostr(article.date * 1000 ,"YYYY/MM/DD")}}</small>｜<span class="cate" :class="'is-cat'+article.category.id" v-if="article.category">{{ article.category.name }}</span></span>
              <h5 class="subject">{{ article.title | truncate }}</h5>
              <span class="desc">{{ article.desc | truncate( 40 )  }}</span>
            </div>
            <div class="tags" v-if="article.keywords != null">
              <span class="tag" v-for="tag in article.keywords">#{{tag}}</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  `

  TAGGED({
    perpage: 12,
    related: 3,
    taglist_disp_list: 'head', // head / foot / both
    taglist_disp_detail: 'foot', // head / foot / both
    taglist_minimumTagAmount : 12, // タグの最低表示数
    taglist_hideUselessTags : 4, // 最低使用回数
    itemTemplate,
    replaceItemTemplate,
    relatedItemTemplate,
    callback()　{
      //ページネーションの位置を移動
      const $pagination = $('.paginationbox');
      if( $pagination.length ) {
        if( mq.matches ) {
          $pagination.prependTo($('#side'));
        } else {
          $pagination.appendTo($('#container'));
        }
      }
    }
  });

  $(() => {
    init()
    if( w.query_string('article') ) detail_init( w.query_string('article') )
  });
}